import { Box, Chip, Typography } from "@mui/material";
import moment from "moment";
import { getUTCYMD } from "utils/timestamp.util";

const ListItem = ({
  data,
  isLast,
  bookingId = "",
  bData,
}: {
  data: any;
  isLast: boolean;
  bookingId?: string;
  bData?: any;
}) => {
  console.log("booking it", data);
  return (
    <Box
      sx={{
        display: "flex",
        gap: { md: "20px", lg: "20px", xl: "20px", sm: "5px", xs: "5px" },
        flexWrap: {
          md: "nowrap",
          lg: "nowrap",
          xl: "nowrap",
          sm: "wrap",
          xs: "wrap",
        },
        justifyContent: "space-between",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          maxWidth: { lg: "60%", xl: "60%", sm: "100%", xs: "100%" },
        }}
      >
        <Box
          component="img"
          src={data?.listings?.images?.[0]?.preview_url}
          alt=""
          sx={{
            height: {
              sm: "96px",
              xs: "96px",
              lg: "88px",
              xl: "88px",
              md: "88px",
            },
            width: {
              sm: "96px",
              xs: "96px",
              lg: "128px",
              xl: "128px",
              md: "128px",
            },
            borderRadius: "8px",
          }}
        />
        <Box
          sx={{
            // borderBottom: !isLast ? "1px solid #E2E2E2" : "",
            flex: 1,

            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: "600",
                lineHeight: "30px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              {data?.listings?.listing_name}
            </Typography>
            <Typography
              sx={{
                lineHeight: "31px",
                color: "#6E8C20",
                fontWeight: 600,
                fontSize: "18px",
              }}
            >
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                currencyDisplay: "narrowSymbol",
              }).format(data?.listings?.price)}{" "}
              • {data?.delivery_type === 0 ? "Pickup" : "Delivery"}
            </Typography>
            <Typography
              sx={{
                color: "#A2A2A2",
                fontSize: {
                  md: "16px",
                  lg: "16px",
                  xl: "16px",
                  sm: "13px",
                  xs: "13px",
                },
                fontWeight: 500,
                lineHeight: "34px",
              }}
            >
              Rental period:{" "}
              {moment(getUTCYMD(bData?.from_date)).format("MMM DD")} -{" "}
              {moment(getUTCYMD(bData?.to_date)).format("MMM DD")}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: {
            md: "column",
            lg: "column",
            xl: "column",
            sm: "row",
            xs: "row",
          },
          justifyContent: {
            md: "center",
            lg: "center",
            xl: "center",
            sm: "space-between",
            xs: "space-between",
          },
          gap: "10px",
          flex: {
            sm: 1,
            xs: 1,
          },
          alignItems: {
            sm: "center",
            xs: "center",
            md: "flex-end",
            lg: "flex-end",
            xl: "flex-end",
          },
        }}
      >
        <Typography
          sx={{ fontWeight: 500, fontSize: "12px", lineHeight: "14px" }}
        >
          Created {moment(data.created_at).fromNow()}
        </Typography>
        <Chip
          label={`Order ID #${bookingId}`}
          sx={{
            background: "#EFFFED",
            color: "#4EA643",
            fontSize: "13px",
            fontWeight: 500,
            lineHeight: "16px",
          }}
        />
      </Box>
    </Box>
  );
};

export default ListItem;
